define('pubsub/scroll',[
    'underscore',
    'cnf',
    '_pubsub'
], function(_,Cnf,Pubsub){
    'use strict';
    
    var oPubsub=new Pubsub(),
        oInstance;
    
    var oScroll=function()
    {
        if(oInstance) {
            return oInstance;
        }
        oInstance=this;
        
        this.init=function()
        {
            this.disableUI=false;
            
            oPubsub.on(Pubsub.DISABLE_SCROLL_UI,_.bind(this.setDisableUI,this));
            
            this.setScroll();
            this.initScroll();
            this.initScrollDelta();
        };
        
        this.initScroll=function()
        {
            Cnf.$window.on('scroll', _.bind(function() {
                _.bind(this.setScroll,this)();
                oPubsub.trigger(Pubsub.SCROLL, {top:Cnf.top});
            },this));
        };
        
        this.setScroll=function()
        {
            Cnf.top=Cnf.$window.scrollTop();
        };
        
        this.setDisableUI=function(bState)
        {
            this.disableUI=bState;
        };
        
        this.initScrollDelta=function()
        {
            Cnf.$window.bind('wheel mousewheel DOMMouseScroll MozMousePixelScroll touchmove', _.bind(function(e) {
                
                if(true===this.disableUI) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                
                //default
                var eData=e.originalEvent || e,
                        iDelta=(eData.deltaY<0) ? -1 : 1;

                if('deltaY' in eData) {
                    iDelta = -eData.deltaY;
                } else if('wheelDeltaY' in eData) {
                    iDelta = eData.wheelDeltaY / 120;
                } else if ( 'wheelDelta' in e ) {
                    iDelta = e.wheelDelta / 120;
                } else if ( 'detail' in e ) {
                    iDelta = -e.detail / 3;
                }

                oPubsub.trigger(Pubsub.SCROLL_DELTA, iDelta);
            },this));
        };
       
       this.init();
    };
    
    return oScroll;
});
